export default __webpack_public_path__ + "static/media/oculus.b5ede475.png";